import { BreakpointProvider, SWAThemeProvider } from '@jetstream/themes';
import './index.scss';

const AuthError = () => {
  return (
    <BreakpointProvider>
      <SWAThemeProvider>
        <div className="error-message">
          WFN UI is currently unable to redirect to Ping. Please contact Service Desk for further
          assistance.
        </div>
      </SWAThemeProvider>
    </BreakpointProvider>
  );
};

export default AuthError;
